export class EditUnavailabilityError extends Error {}